import * as HOSTS from './hosts.js';
import * as MATCHERS from './matchers.js';


/**
 * Gets and returns the current env
 *
 * @returns {String} The environment hostname
 */
export function getEnv() {
    const host = window.location.hostname;
    if (host.match(MATCHERS.DEV)) {
        return HOSTS.DEV;
    }
    return '';
}
